import React from "react";
import {useTranslation} from "react-i18next";
import { Grid, Typography } from "@mui/material";


const BalloonNotification = (props) => {
    const {title = null, header = null, userName = null, municipality = null, content, severity = "", extraElements = [], image = null, ...componentProps} = props;
    const {t} = useTranslation('translation');
    let imageComponent = null;
    if (image) {
        imageComponent = (<img className="icon-image"
                               src={image}
                               alt={t('common.icon')}/>);
    }
    let titleText = "?";
    if(title !== null) {
        titleText = title;
    }

    const contentParser = (text) => {
        const urlRegex = /\[[^[]+?]\(https?:\/\/[^[\]()].+?\)/g;
        const parts = [];
        let lastIndex = 0;
        let match;
        let key = 0;

        while ((match = urlRegex.exec(text)) !== null) {
            if (match.index > lastIndex) {
                parts.push(<span key={key++}>{addNewlines(text.slice(lastIndex, match.index))}</span>);
            }

            const newMatch = match[0].match(/\[([^\]]+)]\(([^)]+)\)/);
            parts.push(<a key={key++} href={newMatch[2]} target="_blank" rel="noopener noreferrer">{newMatch[1]}</a>);
            lastIndex = urlRegex.lastIndex;
        }
        if (lastIndex < text.length) {
            parts.push(<span key={key}>{addNewlines(text.slice(lastIndex))}</span>);
        }

        return <p>{parts}</p>
    }

    function addNewlines(text) {
        const parts = text.split('\n');
        return parts.map((part, i) => (
            <span key={i}>{part}{i < parts.length - 1 && <br />}</span>
        ));
    }
    return (
        <Grid {...componentProps} className={'balloon-notification-container'} sx={{
            minWidth: "auto"
          }}>
            <Grid className={'balloon-notification-top'}>
                <div>
                    <div className={`title ${severity}`}>
                        {imageComponent}
                        <div>{titleText}</div>
                    </div>
                </div>
                <Grid sx={{paddingLeft: "2vh"}}>
                    {header !== null && (<Typography variant="h5" sx={{fontWeight: "bold"}}>
                        {header}
                    </Typography>)}
                    {municipality !== null && userName !== null && <div>{municipality+" - "+userName}</div>}
                    {userName !== null && municipality === null && <div>{userName}</div>}
                    {userName === null && municipality !== null && <div>{municipality}</div>}
                    <div className={'extra-elements'}>
                        {extraElements.map((element, index) => (
                            <div
                                className={`extra-element`}
                                key={`extra-element-${index}`}>
                                    {element}
                            </div>
                        ))}
                    </div>
                </Grid>
            </Grid>
            <Grid sx={{ borderTop: "1px solid", borderColor: "grey.300",}} className={'content mainPageText'}>
                {contentParser(content)}
            </Grid>
        </Grid>
    );
}

export {BalloonNotification}